import {Component, Input} from "@angular/core";
import {Message, MessageType} from "../common/message";

@Component({
	selector: "avdb-message",
	template: `
		<div [class]="getContainerClass()">
			<i [class]="getIconClass()"></i>
			<span class="databasepricing_message_text" [innerHTML]="message.text"></span>
		</div>
	`,
	styles: [],
})
export class AvdbMessageComponent {
	@Input() message: Message;

	getContainerClass(): string {
		switch (this.message.severity) {
			case MessageType.Success:
				return "statuscolor-green";
			case MessageType.Warning:
				return "statuscolor-orange";
			case MessageType.Alert:
				return "statuscolor-red";
			case MessageType.Info:
				return "statuscolor-blue";
			default:
				return "";
		}
	}

	getIconClass(): string {
		switch (this.message.severity) {
			case MessageType.Success:
				return "fa fa-check-circle";
			case MessageType.Warning:
				return "fa fa-exclamation-triangle";
			case MessageType.Alert:
				return "fa fa-minus-circle";
			case MessageType.Info:
				return "fa fa-info-circle";
			default:
				return "";
		}
	}
}
